import applyFilters from "./applyfilter";

export default function changeOnScroll(form: HTMLFormElement) {
    let observeHeadings = (entries: Array<IntersectionObserverEntry>) => {
        let first = entries.find((entry) => entry.isIntersecting);
    
        if(first != undefined && first.target instanceof HTMLElement && first.target.dataset.filter) {
            let filter = JSON.parse(first.target.dataset.filter);

            if(filter instanceof Object) {
                let change = false;
                for(const key in filter) {
                    let field = form.querySelector('input[name='+key+']');
                    if(field instanceof HTMLInputElement) {
                        if(field.value != filter[key]) {
                            field.value = filter[key];
                            change = true;
                        }
                    }
                }

                if(change) {
                    applyFilters(form,false).then(() => {
                        observer.disconnect();
                        attachHeadings();
                    });
                }
            }
        }
    }

    let observer = new IntersectionObserver(observeHeadings);

    let attachHeadings = () => {
        let headings = form.closest('.wp-block-taxonomy-filter-filtered-posts')?.querySelectorAll('.filter-jump-heading');

        if(headings != null) {
            for(let heading of headings) {
                observer.observe(heading);
            }
        }
    }

    attachHeadings();
}